import { Progress } from '@chakra-ui/react';

const ProgressTrack = ({ progress }: { progress: number }) => (
  <Progress
    value={progress}
    colorScheme="green"
    h="4px"
    borderRadius="full"
    bg="platinum"
    sx={{ '& > div': { transition: 'width 400ms ease' } }}
  />
);

export default ProgressTrack;
